import React from 'react';

import HeaderContainer from 'containers/HeaderContainer';
import UserAPI from 'service/api/UserAPI';
import AppConstants from 'AppConstants';
import {A} from 'views/AppElements';
import {Helmet} from "react-helmet";
import Footer from 'views/Footer';

class AccountVerificationPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {verified: null};
	}

	componentDidMount() {
		const match = this.props.match;
		const token = match.params.token;
		UserAPI.verifyAccount(token, function(verified) {
			this.setState({verified: verified});
		}.bind(this));
	}

	render() {
		const verified = this.state.verified;
		return (
				<div>
					<Helmet>
						<title>Verify your Seto Canvas Account | Seto Canvas</title>
    					<meta name="description" content="Seto Canvas is a marketplace for Designers to sell their art printed on merchandise like TShirts, Mugs, Pillows and more." />
					</Helmet>

					<HeaderContainer />

					<h3 style={{textAlign: "center", margin: "40px 0"}}>
						{verified === null && <span><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> Verifying your account</span>}
						{verified === true && <span><i className="fa fa-check-circle-o" style={{color: "#1e8910"}} aria-hidden="true"></i> Your account has been verified successfully. Click <b><A href="/">here</A></b> to continue using {AppConstants.APP_NAME}.</span>}
						{verified === false && <span><i className="fa fa-exclamation-triangle" style={{color: "rgb(158, 56, 50)"}} aria-hidden="true"></i> We could not verify your account. Please request another verification link.</span>}
					</h3>

					<Footer />
				</div>
			);
		
	}
}


export default AccountVerificationPage;


// WEBPACK FOOTER //
// ./src/pages/AccountVerificationPage.js